function PageHeader({ eyebrow, title, description, actions, meta }) {
  const hasActions = Boolean(actions || meta);

  return (
    <section className="page-header">
      <div className="page-header-copy">
        {eyebrow ? <p className="page-eyebrow">{eyebrow}</p> : null}
        <h2 className="page-title">{title}</h2>
        {description ? <p className="page-description">{description}</p> : null}
      </div>

      {hasActions ? (
        <div className="page-actions">
          {meta ? <div className="page-meta">{meta}</div> : null}
          {actions}
        </div>
      ) : null}
    </section>
  );
}

export default PageHeader;
